import { Box } from "@chakra-ui/react";
import { FC, useLayoutEffect } from "react";

import { SearchInput } from "../../../../shared/Inputs";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";

export const SbpTransferBanksPageInput: FC = () => {
  const bankSearch = useSbpTransferStore(s => s.bankSearch);
  const setBankSearch = useSbpTransferStore(s => s.setBankSearch);
  const setSelectedBankSchema = useSbpTransferStore(s => s.setSelectedBankSchema);

  useLayoutEffect(() => {
    setBankSearch("");
  }, []);

  const onChange = (newValue: string) => {
    const formattedValue = newValue
      .replace(/^\s+/, "")
      .replace(/\s+/g, " ");

    setBankSearch(formattedValue);
    setSelectedBankSchema("");
  };

  const onClear = () => {
    setBankSearch("");
    setSelectedBankSchema("");
  };

  return (
    <Box mt="8px">
      <SearchInput
        value={bankSearch}
        onChange={(e) => { onChange(e.target.value); }}
        onClear={onClear}
      />
    </Box>
  );
};
